import { Component } from 'react';
import AgentFilter from 'legacy/javascripts/components/agent_filter.es6.jsx';
import DateRangePicker from 'legacy/javascripts/components/date_range_picker.es6.jsx';
import { DateTime, usaDateFormat } from 'common/utils/date';

class HeaderFilters extends Component {
  getDateRange() {
    return {
      start: DateTime.fromFormat(this.props.data.startDate, usaDateFormat),
      end: DateTime.fromFormat(this.props.data.endDate, usaDateFormat),
      solicitation_reporting_timestamp: this.props.data.timestamp,
    };
  }

  render() {
    let styles = {
      padding: '0 15px 15px 15px',
    };
    let filterTitleStyle = {
      margin: '15px 0',
      fontSize: '16px',
    };

    let agentFilter =
      Object.keys(this.props.data.employees).length > 1 ? (
        <AgentFilter
          handler={this.props.handler}
          data={this.props.data.employees}
          selected={this.props.data.selected}
        />
      ) : null;

    return (
      <div style={styles} className="row">
        {agentFilter}
        <div className="col-md-4">
          <h4 style={filterTitleStyle}>Date range</h4>
          <label htmlFor="daterange" className="datepicker-wrapper">
            <DateRangePicker
              onApply={this.props.handler}
              range={this.getDateRange()}
            />
          </label>
        </div>
      </div>
    );
  }
}

export default HeaderFilters;
